"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogMessageDataType = void 0;
var LogMessageDataType;
(function (LogMessageDataType) {
    LogMessageDataType[LogMessageDataType["STRING"] = 0] = "STRING";
    LogMessageDataType[LogMessageDataType["RAW_STRING"] = 1] = "RAW_STRING";
    LogMessageDataType[LogMessageDataType["PLAYER"] = 2] = "PLAYER";
    LogMessageDataType[LogMessageDataType["CARD"] = 3] = "CARD";
    LogMessageDataType[LogMessageDataType["AWARD"] = 4] = "AWARD";
    LogMessageDataType[LogMessageDataType["MILESTONE"] = 5] = "MILESTONE";
    LogMessageDataType[LogMessageDataType["COLONY"] = 6] = "COLONY";
    LogMessageDataType[LogMessageDataType["_STANDARD_PROJECT"] = 7] = "_STANDARD_PROJECT";
    LogMessageDataType[LogMessageDataType["PARTY"] = 8] = "PARTY";
    LogMessageDataType[LogMessageDataType["TILE_TYPE"] = 9] = "TILE_TYPE";
    LogMessageDataType[LogMessageDataType["SPACE_BONUS"] = 10] = "SPACE_BONUS";
    LogMessageDataType[LogMessageDataType["GLOBAL_EVENT"] = 11] = "GLOBAL_EVENT";
    LogMessageDataType[LogMessageDataType["UNDERGROUND_TOKEN"] = 12] = "UNDERGROUND_TOKEN";
    LogMessageDataType[LogMessageDataType["SPACE"] = 13] = "SPACE";
    LogMessageDataType[LogMessageDataType["CARDS"] = 14] = "CARDS";
})(LogMessageDataType || (exports.LogMessageDataType = LogMessageDataType = {}));
